// Higher privilege roles appear first when a user has more than one assignment.
const ROLE_PRIORITY = ["SustainAdmin", "SuperAdmin", "Admin", "OpsTeam", "Ops", "GlobalAnnouncer", "Developer", "General"];

export const friendlyRole = (role) => role === "OpsTeam" ? "Ops" : role;

export function sortRoles(groups = []) {
  return [...new Set(groups)].sort((first, second) => {
    const firstRank = ROLE_PRIORITY.indexOf(first);
    const secondRank = ROLE_PRIORITY.indexOf(second);
    return (firstRank < 0 ? ROLE_PRIORITY.length : firstRank) - (secondRank < 0 ? ROLE_PRIORITY.length : secondRank)
      || first.localeCompare(second);
  });
}

export const highestRole = (groups) => sortRoles(groups)[0] || "General";
